export const ARTIFACTS_PAGE_LENGTH = 10;
export const CONTAINERS_IMAGES_PAGE_LENGTH = 20;
// TODO: refactor to use ARTIFACTS_PAGE_LENGTH directly
export const CONTAINERS_IMAGE_TAGS_PAGE_LENGTH = ARTIFACTS_PAGE_LENGTH;
export const PACKAGES_PAGE_LENGTH = 20;
export const CONTAINERS_RESOURCE_EXPIRY = 60 * 1000 * 1;
export const PACKAGES_RESOURCE_EXPIRY = 60 * 1000 * 1;

export const SORT_QUERY_PARAM = 'sort';
export const PAGE_QUERY_PARAM = 'page';
export const PAGELEN_QUERY_PARAM = 'pagelen';
export const SEARCH_PACKAGE_NAME_QUERY_PARAM = 'name';
export const SEARCH_TAG_NAME_QUERY_PARAM = 'tagName';
export const SEARCH_MAVEN_BASE_VERSION_QUERY_PARAM = 'baseVersion';
export const SEARCH_VERSION_QUERY_PARAM = 'version';
export const PACKAGE_TYPE_QUERY_PARAM = 'packageType';

export const REGISTRY_HOSTNAME = 'crg.apkg.io';
